import { Carousel } from "~/components/blocks/vod/top/common/category-carousel/carousel";
import type { Links } from "~/components/blocks/vod/top/hooks/use-set-link-data";

import type { G_FetchHomeQuery } from "~/lib/graphql";

type CategoryCarouselProps = {
  isVideoSubPage: boolean;
  categories: Links;
  allVideoSubPages?: G_FetchHomeQuery["home"]["allVideoSubPages"];
};
export const CategoryCarousel = ({ isVideoSubPage, categories }: CategoryCarouselProps) => {
  // memo: カテゴリカルーセルはアイテムが存在しない場合は描画しない
  if (categories.length === 0) return null;
  return <Carousel categories={categories} isVideoSubPage={isVideoSubPage} />;
};
